import {Component, OnInit, ViewChild} from '@angular/core';
import {RicambiService} from '../service/ricambi.service';

import {Evento} from '../models/evento';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Location} from '@angular/common';
import 'rxjs/add/operator/switchMap';
@Component({
    selector: 'app-tws-bacheca',
    templateUrl: './tws-bacheca.component.html',
    styleUrls: ['./tws-bacheca.component.css']
})
export class TwsBachecaComponent implements OnInit {
    eventi: Array<Evento> = new Array<Evento>();//in teoria ho l'albero e posso metterlo in cache
    constructor(private ricambiService: RicambiService) {
        this.ricambiService.getEventi().then(eventi => this.risultatiRicerca(eventi));

    }
    risultatiRicerca(mac: Evento[]): void {
        this.eventi = mac;
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/tws-bacheca/tws-bacheca.component.ts